<template>
  <div class="seats-counter" :class="severityClass" :title="`${used} sièges utilisés sur ${total}`">
    <span class="seats-num">{{ used }}<span class="seats-sep">/</span>{{ total || '∞' }}</span>
    <span class="seats-label">{{ used > 1 ? 'sièges' : 'siège' }}</span>
  </div>
</template>

<script>
export default {
  name: 'SeatsCounter',
  props: {
    used: { type: Number, required: true },
    total: { type: Number, default: 0 }
  },
  computed: {
    severityClass() {
      if (!this.total) return 'severity-ok';
      const r = this.used / this.total;
      if (r >= 1) return 'severity-full';
      if (r >= 0.85) return 'severity-warn';
      return 'severity-ok';
    }
  }
};
</script>

<style scoped>
.seats-counter {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 6px;
  font-weight: 500;
  border: 1px solid transparent;
}
.seats-num { font-variant-numeric: tabular-nums; font-weight: 600; }
.seats-sep { opacity: 0.5; margin: 0 2px; }
.seats-label { font-size: 0.85em; opacity: 0.8; }
.severity-ok    { background: #e8f5e9; color: #2e7d32; border-color: #c8e6c9; }
.severity-warn  { background: #fff3e0; color: #e65100; border-color: #ffe0b2; }
.severity-full  { background: #ffebee; color: #c62828; border-color: #ffcdd2; }
</style>
